export default {
    clip_request_url: "Thumbnail Url",
    clip_request_transaction_id: "Transaction Id",
    clip_request_clip_date: "Clip Date",
    clip_request_upload_type: "Upload Type",
    clip_request_status: "Status",
    clip_request_time_frame: "Time Frame",
    clip_request_driver: "Driver",
    clip_request_unit: "Unit",
    clip_request_requestor: "Requestor",
    clip_request_error_msg: "Error Message",
    clip_request_new_clip: "New Clip",
}